import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// const api = "http://10.53.25.122:5000"
// const apiTesting = "http://10.53.26.148:5000"

//json server
const api = "http://localhost:3000"

export const fetchPrizes = async ({state, commit}) => {
  try {
    commit("SET_LOADING", true)
    const {data} = await axios.get(`${process.env.VUE_APP_API2}/api/prizes`)
    // console.log(s, "MASUK SINI")
    if (data) {
      console.log('hadiah >',data);
      commit('SET_PRIZES', data)
      commit("SET_LOADING", false)
      // console.log(state.isLoading, "MASUK SINI")
      commit('saveAndResetDoorprize')
    } else {

      console.log("data gada")
    }

  } catch (err) {
    console.log("ERRORNIH")
    console.log(err)
  }
}

export const fetchFromLocalStorage = ({commit}) => {
  try {
    const data = localStorage.getItem("prizeLists")

    commit('SET_PRIZES', JSON.parse(data))
  } catch (err) {
    console.log(err)
  }
}